export default {

  setBookingSchedule: (state, bookingSchedule) => {
    state.bookingSchedule = bookingSchedule;
  },

  setBookingScheduleFilter: (state, bookingScheduleFilter) => {
    state.bookingScheduleFilter = bookingScheduleFilter;
  }
};
